import { ReactNode } from 'react';
import styled from 'styled-components';

import { getColor, getColorFromTheme } from '@utils/theme';

import { ColorTypes, TintTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

export type ITextVariants =
	| 'body'
	| 'small'
	| 'smallText'
	| 'field'
	| 'button'
	| 'footer'
	| 'pill'
	| 'pillText'
	| 'fineprint'
	| 'fineprintBold';

export interface IBasicTextProps {
	color?: ColorTypes;
	children?: ReactNode;
	tint?: TintTypes;
	variant?: ITextVariants;
	underline?: boolean;
}

const BasicText = styled.p<IBasicTextProps>`
	font-family: ${({ theme: components }) => components.fontFamily};
	font-size: ${({ variant = 'body', theme: components }) =>
		components.basicText[variant].fontSize.mobile};
	line-height: ${({ variant = 'body', theme: components }) =>
		components.basicText[variant].lineHeight};
	font-weight: ${({ variant = 'body', theme: components }) =>
		components.basicText[variant].fontWeight};
	color: ${({ theme: components, color, tint }) =>
		color
			? getColor(color, tint)
			: getColorFromTheme(components.bodyText.color, components.bodyText.tint)};
	border-bottom: ${({ underline }) => underline && `1px solid ${theme.colors.black}`};

	@media ${theme.responsive.breakpoints.tablet} {
		font-size: ${({ variant = 'body', theme: components }) =>
			components.basicText[variant].fontSize.tablet};
	}
`;

export default BasicText;
